import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pwa-bottom-nav"
}
const _hoisted_2 = { class: "nav-icon-wrapper" }
const _hoisted_3 = { class: "nav-label" }

import { computed } from 'vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'PwaLayout',
  setup(__props) {

const route = useRoute();

// 로그인/회원가입 페이지에서는 하단 네비 숨김
const hideNav = computed(() => {
  const hiddenPaths = ['/pwa/login', '/pwa/signup'];
  return hiddenPaths.includes(route.path);
});

const navItems = [
  {
    path: '/pwa/employees',
    label: '직원',
    icon: 'mdi-account-group',
    activeColor: '#1e3a8a'
  },
  {
    path: '/pwa/payroll',
    label: '급여',
    icon: 'mdi-currency-krw',
    activeColor: '#1e3a8a'
  },
  {
    path: '/pwa/home',
    label: '홈',
    icon: 'mdi-home',
    activeColor: '#1e3a8a'
  },
  {
    path: '/pwa/finance',
    label: '회계',
    icon: 'mdi-cash-multiple',
    activeColor: '#1e3a8a'
  },
  {
    path: '/pwa/settings',
    label: '더보기',
    icon: 'mdi-dots-horizontal',
    activeColor: '#1e3a8a'
  }
];

const isActiveRoute = (path: string): boolean => {
  return route.path === path || route.path.startsWith(path + '/');
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { class: "pwa-layout" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["pwa-content-wrapper", { 'no-nav': hideNav.value }])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2),
      (!hideNav.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
              return _createVNode(_component_router_link, {
                key: item.path,
                to: item.path,
                class: _normalizeClass(["nav-item", { active: isActiveRoute(item.path) }])
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_v_icon, {
                      size: 24,
                      color: isActiveRoute(item.path) ? item.activeColor : '#9ca3af'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.icon), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"])
            }), 64))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})